import PageBox from "../../components/PageBox/PageBox.component";
import styles from "./Style.module.css";
import useHierarchyReport from "./HierarchyReport.hook";
import HierarchyFields from "./component/TopBarFields/TopBarFields.view";
import HierarchyTable from "./component/HierarchyTable/HierarchyTable.view";
import { CircularProgress } from "@material-ui/core";

const labels = [
  { text: "L0 (TBM)", color: "#ffffff", textColor: "#161616" },
  { text: "L1 (ABM)", color: "#E0FFFC", textColor: "#161616" },
  { text: "L2 (RBM)", color: "#F7E4FF", textColor: "#161616" },
  { text: "L3 (ZBM)", color: "#E4FFED", textColor: "#161616" },
  { text: "L4 (DBM)", color: "#FFF0E4", textColor: "#161616" },
  { text: "L5 (DGM/GM)", color: "#FFD8DC", textColor: "#161616" },
  {
    text: "L6 (VP)",
    color: "#DFD8FF",
    textColor: "#161616",
  },
];

const HierarchyReport = ({ location }) => {
  const { isSubmitting, currentData, form, changeTextData, handleDownload ,downloading} =
    useHierarchyReport({
      location,
    });

  return (
    <div>
      <PageBox>
        <div className={styles.headerContainer}>
          <div>
            <span className={styles.title}>Hierarchy Report</span>
            <div className={styles.newLine} />
          </div>
          <div className={styles.containerBadge}>
            {labels.map((label, idx) => (
              <span
                key={idx}
                className={styles.badge}
                style={{ backgroundColor: label.color, color: label.textColor }}
              >
                {label.text}
              </span>
            ))}
          </div>
        </div>
        <br />
        <HierarchyFields
          form={form}
          changeTextData={changeTextData}
          downloading={downloading}
          handleDownload={handleDownload}
        />
      </PageBox>
      <br />
      {isSubmitting ? (
        <div className={styles.loader}>
          <CircularProgress color="success" size="20px" />
        </div>
      ) : (
        <HierarchyTable currentData={currentData} />
      )}
    </div>
  );
};

export default HierarchyReport;
